export function hasDirectClaimAccess(claim, customerId) {
  if (!claim || customerId == null) return false;
  const customerIdStr = String(customerId);
  return (
    String(claim.contact_claims_handler_id) === customerIdStr ||
    String(claim.adjusters_assistant_id) === customerIdStr ||
    String(claim.nurse_case_manager_id) === customerIdStr ||
    String(claim.field_case_manager_id) === customerIdStr
  );
}

/** Duplicate-check API includes an explicit has_direct_access flag. */
export function hasDirectClaimAccessFromDuplicate(claim, customerId) {
  return hasDirectClaimAccess(claim, customerId) || claim?.has_direct_access === true;
}

export function claimRolePromptSkipKey(customerId, claimId) {
  return `claimRolePromptDismissed:${customerId}:${claimId}`;
}

export function wasClaimRolePromptSkipped(customerId, claimId) {
  if (customerId == null || claimId == null) return false;
  try {
    return sessionStorage.getItem(claimRolePromptSkipKey(customerId, claimId)) === '1';
  } catch (e) {
    return false;
  }
}

export function skipClaimRolePrompt(customerId, claimId) {
  if (customerId == null || claimId == null) return;
  try {
    sessionStorage.setItem(claimRolePromptSkipKey(customerId, claimId), '1');
  } catch (e) {
    // ignore storage failures
  }
}
